import React from "react";

const Squares = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.616455 7.05828V0.592529H7.08221V7.05828H0.616455ZM0.616455 15.1405V8.67472H7.08221V15.1405H0.616455ZM8.69865 7.05828V0.592529H15.1644V7.05828H8.69865ZM8.69865 15.1405V8.67472H15.1644V15.1405H8.69865ZM2.23289 5.44184H5.46577V2.20897H2.23289V5.44184ZM10.3151 5.44184H13.548V2.20897H10.3151V5.44184ZM10.3151 13.524H13.548V10.2912H10.3151V13.524ZM2.23289 13.524H5.46577V10.2912H2.23289V13.524Z"
        fill="#F2F8ED"
      />
    </svg>
  );
};

export default Squares;
